import { useEffect } from "react";
import { Sheet } from "../components/ui";
import { useStore } from "../state/store";
import { dismiss, toasts, type Toast } from "../state/toasts";
import { signing } from "../wallet/signer";

const PURPOSE: Record<string, { title: string; body: string }> = {
  registerSessionKey: {
    title: "Turn on one-tap bets",
    body: "Sign once on HyperEVM to register a 30-day session key. It places and cashes out bets for you and can never withdraw. No gas.",
  },
  withdraw: { title: "Withdraw", body: "Sign the withdrawal to your own HyperCore spot account. No gas." },
  stake: { title: "Stake PAPER", body: "Sign to stake. It takes effect in the next batch. No gas." },
  unstake: { title: "Unstake PAPER", body: "Sign to unstake. Rewards already earned stay claimable. No gas." },
  claim: { title: "Claim rewards", body: "Sign to move your USDC rewards into your balance. No gas." },
  depositToSpot: { title: "Move USDC to spot", body: "Hyperliquid asks your wallet to move the amount from perps to spot first." },
  deposit: { title: "Send the deposit", body: "Hyperliquid asks your wallet to send USDC to your papertrade deposit address." },
};

function ToastItem({ item }: { item: Toast }) {
  useEffect(() => {
    const timer = setTimeout(() => dismiss(item.id), item.tone === "error" ? 9_000 : 5_000);
    return () => clearTimeout(timer);
  }, [item.id, item.tone]);
  return (
    <div className={`toast toast-${item.tone}`} role={item.tone === "error" ? "alert" : "status"}>
      <span className="toast-bar" />
      <div>
        <div className="toast-title">{item.title}</div>
        {item.body && <div className="toast-body num">{item.body}</div>}
      </div>
      <button type="button" className="toast-close" onClick={() => dismiss(item.id)} aria-label="Dismiss">
        ×
      </button>
    </div>
  );
}

export function Toaster() {
  const items = useStore(toasts);
  return (
    <div className="toasts" aria-live="polite">
      {items.map((item) => (
        <ToastItem key={item.id} item={item} />
      ))}
    </div>
  );
}

/** While the wallet is asked to sign: what it is for, so the prompt is never a surprise. */
export function SigningSheet() {
  const asked = useStore(signing);
  const copy = asked ? (PURPOSE[asked.purpose] ?? { title: "Sign in your wallet", body: "" }) : null;
  return (
    <Sheet open={asked !== null} onClose={() => signing.set(null)} title={copy?.title ?? ""}>
      <div className="signing">
        <span className="signing-mark">
          <span className="spinner" />
        </span>
        <div className="toast-title">
          Confirm in your wallet{asked && asked.steps > 1 ? ` · ${asked.step} of ${asked.steps}` : ""}
        </div>
        {copy?.body && <p className="signing-copy">{copy.body}</p>}
      </div>
    </Sheet>
  );
}
